<div class="mfa-login-container">
  <div class="mfa-login-card">
    <div class="mfa-login-header">
      <div class="logo-container mb-3">
        <img src="assets/alt_logo.png" alt="Company Logo" class="company-logo">
      </div>
      <h4>Two-Factor Authentication</h4>
      <p>Enter the code from your authenticator app</p>
    </div>

    <div class="mfa-login-body">
      <div class="mfa-user-info">
        <p class="mb-1">Account:</p>
        <p class="fw-bold mb-0">{{ userEmail }}</p>
      </div>

      <form (ngSubmit)="verifyMfaToken()" #mfaForm="ngForm">
        <div class="mfa-form-group">
          <label for="otp" class="mfa-form-label">Authentication Code</label>
          <input
            type="text"
            id="otp"
            class="mfa-form-control"
            [(ngModel)]="otp"
            name="otp"
            placeholder="123456"
            maxlength="6"
            (input)="onOtpChange($event)"
            autocomplete="off"
            autofocus
            required>
          <div class="mfa-form-text">
            Enter the 6-digit code from your authenticator app
          </div>
        </div>

        @if (errorMessage) {
          <div class="mfa-alert mfa-alert-danger">
            {{ errorMessage }}
          </div>
        }

        <div class="mfa-btn-group">
          <button
            type="submit"
            class="mfa-btn mfa-btn-primary"
            [disabled]="isLoading || !otp || otp.length !== 6">
            @if (isLoading) {
              <span class="spinner-border spinner-border-sm mfa-spinner" role="status" aria-hidden="true"></span>
            }
            @if (!isLoading) {
              <i class="bi bi-shield-lock-fill me-2"></i>
            }
            Verify Code
          </button>

          <button
            type="button"
            class="mfa-btn mfa-btn-secondary"
            (click)="cancelMfa()">
            <i class="bi bi-x-circle-fill me-2"></i>
            Cancel
          </button>
        </div>
      </form>
    </div>

    <div class="mfa-login-footer">
      <small>
        Can't access your authenticator app? Contact your administrator.
      </small>
    </div>
  </div>
</div>